import type { SVGProps } from "react";

type SvgProps = SVGProps<SVGSVGElement>;

const base: SvgProps = {
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2.2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
};

export function ArrowDownIcon(p: SvgProps) {
	return (
		<svg width={16} height={16} viewBox="0 0 24 24" {...base} {...p}>
			<line x1="12" y1="5" x2="12" y2="19" />
			<polyline points="19 12 12 19 5 12" />
		</svg>
	);
}

export function ArrowUpDownIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} {...p}>
			<polyline points="7 4 7 20" />
			<polyline points="3 8 7 4 11 8" />
			<polyline points="17 4 17 20" />
			<polyline points="13 16 17 20 21 16" />
		</svg>
	);
}

export function ArrowRightIcon(p: SvgProps) {
	return (
		<svg width={16} height={16} viewBox="0 0 24 24" {...base} {...p}>
			<line x1="5" y1="12" x2="19" y2="12" />
			<polyline points="12 5 19 12 12 19" />
		</svg>
	);
}

export function ChevronIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} strokeWidth={2.4} {...p}>
			<polyline points="6 9 12 15 18 9" />
		</svg>
	);
}

export function SearchIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} strokeWidth={2} {...p}>
			<circle cx="11" cy="11" r="8" />
			<line x1="21" y1="21" x2="16.65" y2="16.65" />
		</svg>
	);
}

export function CloseIcon(p: SvgProps) {
	return (
		<svg width={16} height={16} viewBox="0 0 24 24" {...base} {...p}>
			<line x1="18" y1="6" x2="6" y2="18" />
			<line x1="6" y1="6" x2="18" y2="18" />
		</svg>
	);
}

export function SunIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} strokeWidth={2} {...p}>
			<circle cx="12" cy="12" r="4" />
			<path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
		</svg>
	);
}

export function MoonIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} strokeWidth={2} {...p}>
			<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
		</svg>
	);
}

export function SwapIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} {...p}>
			<path d="M7 7h13l-3-3M17 17H4l3 3" />
		</svg>
	);
}

export function SendIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} strokeWidth={2} {...p}>
			<line x1="22" y1="2" x2="11" y2="13" />
			<polygon points="22 2 15 22 11 13 2 9 22 2" />
		</svg>
	);
}

export function LoaderIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} strokeWidth={2.4} {...p}>
			<path d="M21 12a9 9 0 1 1-6.2-8.55" />
		</svg>
	);
}

export function CheckIcon(p: SvgProps) {
	return (
		<svg width={16} height={16} viewBox="0 0 24 24" {...base} strokeWidth={2.6} {...p}>
			<polyline points="20 6 9 17 4 12" />
		</svg>
	);
}

export function CopyIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} strokeWidth={2} {...p}>
			<rect x="9" y="9" width="11" height="11" rx="2" />
			<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
		</svg>
	);
}

export function QuestionIcon(p: SvgProps) {
	return (
		<svg width={20} height={20} viewBox="0 0 24 24" {...base} strokeWidth={2} {...p}>
			<circle cx="12" cy="12" r="10" />
			<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
			<line x1="12" y1="17" x2="12.01" y2="17" />
		</svg>
	);
}

export function WalletIcon(p: SvgProps) {
	return (
		<svg width={16} height={16} viewBox="0 0 24 24" {...base} strokeWidth={2} {...p}>
			<path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
			<path d="M16 3H8l-2 4h14l-2-4z" />
			<circle cx="17" cy="13" r="1" fill="currentColor" strokeWidth={0} />
		</svg>
	);
}

export function ExternalLinkIcon(p: SvgProps) {
	return (
		<svg width={12} height={12} viewBox="0 0 24 24" {...base} strokeWidth={2} {...p}>
			<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
			<polyline points="15 3 21 3 21 9" />
			<line x1="10" y1="14" x2="21" y2="3" />
		</svg>
	);
}

export function RefreshIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} strokeWidth={2} {...p}>
			<polyline points="23 4 23 10 17 10" />
			<path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
		</svg>
	);
}

export function AlertIcon(p: SvgProps) {
	return (
		<svg width={14} height={14} viewBox="0 0 24 24" {...base} strokeWidth={2} {...p}>
			<circle cx="12" cy="12" r="10" />
			<line x1="12" y1="8" x2="12" y2="12" />
			<line x1="12" y1="16" x2="12.01" y2="16" />
		</svg>
	);
}
